import { memo, useEffect } from "react";
import { Popover, Table, TableProps } from "antd";
import { mdlCustomer } from "../../models/domain/Customer";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { ExclamationOutlined } from '@ant-design/icons';

export type CustomerTableProps = {
    customers?: mdlCustomer[];
    checkInDate?: Date;
}

export const CustomerTable = memo(function CustomerTable(props: CustomerTableProps) {
    const { t } = useTranslation();

    useEffect(() => {
    }, [props]);

    function calculateAge(dateOfBirth: Date, currentDate: Date): number {
        const birthYear = dateOfBirth.getFullYear();
        const birthMonth = dateOfBirth.getMonth();
        const birthDay = dateOfBirth.getDate();

        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth();
        const currentDay = currentDate.getDate();

        let age = currentYear - birthYear;

        // Adjust age if the current date is before the birthday in the current year
        if (
            currentMonth < birthMonth ||
            (currentMonth === birthMonth && currentDay < birthDay)
        ) {
            age--;
        }

        return age;
    }

    const getContent = (age: number) => {
        return (
            <div>
                <p>{t("customer.customerAgeDiff")} - ({age})</p>
            </div>
        );
    }


    const columns: TableProps<mdlCustomer>['columns'] = [
        {
            title: t("customer.title"),
            dataIndex: 'title',
            key: 'title'
        },
        {
            title: t("customer.nameSurname"),
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: t("customer.nationality"),
            dataIndex: 'nationality',
            key: 'nationality',
        },
        {
            title: t("customer.birthDate"),
            key: 'birthDate',
            render: (e: mdlCustomer) => {
                return e.birthDate && dayjs(e.birthDate) > dayjs("1902-01-01") ? dayjs(e.birthDate, ("YYYY-MM-DD")).format("DD.MM.YYYY") : "-"
            }
        },
        {
            title: t("customer.age"),
            key: 'age',
            render: (e: mdlCustomer) => {
                if (e.age != null && props.checkInDate && e.birthDate && e.birthDate.toString() != "0001-01-01T00:00:00") {
                    const age = calculateAge(dayjs(e.birthDate).toDate(), dayjs(props.checkInDate).toDate());
                    if (age != e.age) {
                        return (
                            <Popover content={getContent(age)} title={t("customer.ageDifferenceTitle")}>
                                <div>{e.age}
                                    <ExclamationOutlined style={{ fontWeight: "bolder", fontSize: "large", color: "red" }} />
                                </div>
                            </Popover>
                        )
                    }
                    else {
                        return e.age;
                    }
                } else {
                    return e.age;
                }
            }
        },
        {
            title: t("customer.arrival"),
            key: 'arrival',
            dataIndex: 'arrival',
        },
        {
            title: t("customer.departure"),
            key: 'departure',
            dataIndex: 'departure',
        },

    ];

    return (
        <>
            {
                props.customers
                &&
                <Table<mdlCustomer>
                    size="small"
                    columns={columns}
                    dataSource={props.customers.map((customer: mdlCustomer, index: number) => ({ ...customer, key: index }))}
                    pagination={false}
                />
            }
        </>
    )
})